export enum QuickActionsConstants {
  CARDIAC_ARREST_ROUTE = '/tabs/cardiacArrest',
  SET_QUICK_ACTIONS = 'quickActions/SET_QUICK_ACTIONS',
  SET_QUICK_ACTION_BUTTONS = 'quickActions/SET_QUICK_ACTION_BUTTONS',
  SET_FILTERED_QUICK_ACTION_BUTTONS = 'quickActions/SET_FILTERED_QUICK_ACTION_BUTTONS',
  FILTER_QUICK_ACTION_BUTTONS = 'quickActions/FILTER_QUICK_ACTION_BUTTONS',
  QUICK_ACTION_BUTTONS_ROUTE = '/tabs/quickActionButtons',
  SET_QUICK_ACTION_BUTTON_ROWS = 'quickActions/SET_QUICK_ACTION_BUTTON_ROWS',
  SET_MOBILE_QUICK_ACTION_BUTTON_ROWS = 'quickActions/SET_MOBILE_QUICK_ACTION_BUTTON_ROWS',
  SET_SELECTED_QUICK_ACTION_BUTTON_ID = 'quickActions/SET_SELECTED_QUICK_ACTION_BUTTON_ID',
  SET_SELECTED_QUICK_ACTION_BUTTON = 'quickActions/SET_SELECTED_QUICK_ACTION_BUTTON',
  UPDATE_QUICK_ACTION_BUTTON = 'quickActions/UPDATE_QUICK_ACTION_BUTTON',
  SET_PARENT_QUICK_ACTION_LABEL = 'quickActions/SET_PARENT_QUICK_ACTION_LABEL',
  SET_IS_MEDICATION_BUTTON_TYPE = 'quickActions/SET_IS_MEDICATION_BUTTON_TYPE',
  SET_IS_PROCEDURE_BUTTON_TYPE = 'quickActions/SET_IS_PROCEDURE_BUTTON_TYPE',
  SET_IS_VITAL_BUTTON_TYPE = 'quickActions/SET_IS_VITAL_BUTTON_TYPE',
  SET_IS_CARDIAC_BUTTON_TYPE = 'quickActions/SET_IS_CARDIAC_BUTTON_TYPE',
  SET_IS_INTUBATION_BUTTON_TYPE = 'quickActions/SET_IS_INTUBATION_BUTTON_TYPE',
  SET_IS_AIRWAY_BUTTON_TYPE = 'quickActions/SET_IS_AIRWAY_BUTTON_TYPE',
  SET_IS_CHILDBIRTHOB_BUTTON_TYPE = 'quickActions/SET_IS_CHILDBIRTHOB_BUTTON_TYPE',
  SET_IS_EXTRICATION_BUTTON_TYPE = 'quickActions/SET_IS_EXTRICATION_BUTTON_TYPE',
  SET_IS_INITIATE_IV_BUTTON_TYPE = 'quickActions/SET_IS_INITIATE_IV_BUTTON_TYPE',
  SET_IS_IMMOBILIZATION_BUTTON_TYPE = 'quickActions/SET_IS_IMMOBILIZATION_BUTTON_TYPE',
  SET_IS_MEDICAL_CONSULT_BUTTON_TYPE = 'quickActions/SET_IS_MEDICAL_CONSULT_BUTTON_TYPE',
  SET_IS_OPERATIONS_BUTTON_TYPE = 'quickActions/SET_IS_OPERATIONS_BUTTON_TYPE',
  SET_IS_RESCUE_BUTTON_TYPE = 'quickActions/SET_IS_RESCUE_BUTTON_TYPE',
  SET_IS_VENTILATOR_BUTTON_TYPE = 'quickActions/SET_IS_VENTILATOR_BUTTON_TYPE',
  SET_IS_BLOOD_PRODUCT_ADMINISTRATION_BUTTON_TYPE = 'quickActions/SET_IS_BLOOD_PRODUCT_ADMINISTRATION_BUTTON_TYPE',
  SET_IS_WOUND_CARE_BUTTON_TYPE = 'quickActions/SET_IS_WOUND_CARE_BUTTON_TYPE',
  SET_IS_CRITICAL_CARE_BUTTON_TYPE = 'quickActions/SET_IS_CRITICAL_CARE_BUTTON_TYPE',
  SET_IS_HOSPITAL_NOTIFY_BUTTON_TYPE = 'quickActions/SET_IS_HOSPITAL_NOTIFY_BUTTON_TYPE',
  SET_ADD_INTUBATION_TO_TIMELINE = 'quickActions/SET_ADD_INTUBATION_TO_TIMELINE',
  SET_ADD_MEDICATION_TO_TIMELINE = 'quickActions/SET_ADD_MEDICATION_TO_TIMELINE',
  SET_ADD_CARDIAC_TO_TIMELINE = 'quickActions/SET_ADD_CARDIAC_TO_TIMELINE',
  SET_ADD_DRAIN_TO_TIMELINE = 'quickActions/SET_ADD_DRAIN_TO_TIMELINE',
  SET_ADD_AIRWAY_TO_TIMELINE = 'quickActions/SET_ADD_AIRWAY_TO_TIMELINE',
  SET_ADD_CHILDBIRTHOB_TO_TIMELINE = 'quickActions/SET_ADD_CHILDBIRTHOB_TO_TIMELINE',
  SET_ADD_EXTRICATION_TO_TIMELINE = 'quickActions/SET_ADD_EXTRICATION_TO_TIMELINE',
  SET_ADD_INITIATE_IV_TO_TIMELINE = 'quickActions/SET_ADD_INITIATE_IV_TO_TIMELINE',
  SET_ADD_IMMOBILIZATION_TO_TIMELINE = 'quickActions/SET_ADD_IMMOBILIZATION_TO_TIMELINE',
  SET_ADD_MEDICAL_CONSULT_TO_TIMELINE = 'quickActions/SET_ADD_MEDICAL_CONSULT_TO_TIMELINE',
  SET_ADD_OPERATIONS_TO_TIMELINE = 'quickActions/SET_ADD_OPERATIONS_TO_TIMELINE',
  SET_ADD_RESCUE_TO_TIMELINE = 'quickActions/SET_ADD_RESCUE_TO_TIMELINE',
  SET_IS_DRAIN_BUTTON_TYPE = 'quickActions/SET_IS_DRAIN_BUTTON_TYPE',
  SET_ADD_VENTILATOR_TO_TIMELINE = 'quickActions/SET_ADD_VENTILATOR_TO_TIMELINE',
  SET_ADD_BLOOD_PRODUCT_ADMINISTRATION_TO_TIMELINE = 'quickActions/SET_ADD_BLOOD_PRODUCT_ADMINISTRATION_TO_TIMELINE',
  SET_ADD_WOUND_CARE_TO_TIMELINE = 'quickActions/SET_ADD_WOUND_CARE_TO_TIMELINE',
  SET_ADD_CRITICAL_CARE_TO_TIMELINE = 'quickActions/SET_ADD_CRITICAL_CARE_TO_TIMELINE',
  SET_IS_TITRATE_BUTTON_TYPE = 'quickActions/SET_IS_TITRATE_BUTTON_TYPE',
  SET_ADD_HOSPITAL_NOTIFY_TO_TIMELINE = 'quickActions/SET_ADD_HOSPITAL_NOTIFY_TO_TIMELINE',
  SET_SAVED_QUICK_ACTION_BUTTONS = 'quickActions/SET_SAVED_QUICK_ACTION_BUTTONS',
  SET_RESPONSE = 'quickActions/SET_RESPONSE',
  RESET_STATE = 'quickActions/RESET_STATE',
  SET_SELECTED_QUICK_ACTION_BUTTON_TYPE = 'quickActions/SET_SELECTED_QUICK_ACTION_BUTTON_TYPE',
  SET_SAVED_QUICK_ACTION_BUTTONS_FOR_NOTIFICATION = 'quickActions/SET_SAVED_QUICK_ACTION_BUTTONS_FOR_NOTIFICATION',
  SET_LOCAL_NOTIFICATIONS = 'quickActions/SET_LOCAL_NOTIFICATIONS',
  SET_LOCAL_NOTIFICATIONS_TO_CANCEL = 'quickActions/SET_LOCAL_NOTIFICATIONS_TO_CANCEL',
  RESET_LOCAL_NOTIFICATIONS_TO_CANCEL = 'quickActions/RESET_LOCAL_NOTIFICATIONS_TO_CANCEL',
  SET_IS_LABS_BUTTON_TYPE = 'quickActions/SET_IS_LABS_BUTTON_TYPE',
  SET_IS_VENTRICULAR_ASSIST_DEVICE_BUTTON_TYPE = 'quickActions/SET_IS_VENTRICULAR_ASSIST_DEVICE_BUTTON_TYPE',
  SET_ADD_VENTRICULAR_ASSIST_DEVICE_TO_TIMELINE = 'quickActions/SET_ADD_VENTRICULAR_ASSIST_DEVICE_TO_TIMELINE',
}
